import React from 'react';

export default class Neutral extends React.PureComponent {
  render() {
    const radius = this.props.canvasSize / 2;
    return (
      <g fill="none">
        <circle className="fill-current" cx={radius} cy={radius} r={radius} />
        <path
          d="M23 27c2.21 0 4-2.686 4-6s-1.79-6-4-6-4 2.686-4 6 1.79 6 4 6zm18 0c2.21 0 4-2.686 4-6s-1.79-6-4-6-4 2.686-4 6 1.79 6 4 6zM26 41h11v4H26z"
          style={{ fill: 'rgba(0,0,0,0.67)' }}
        />
      </g>
    );
  }
}
